import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { VersionUpdateService } from './shared/services/version-update.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <router-outlet></router-outlet>
  `,
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit {
  private versionUpdateService = inject(VersionUpdateService);

  async ngOnInit() {
    // VersionUpdateService initializes update checks automatically in its constructor
  }
}
